export const preventHistoryBack = () => {
  const currentUrl = window.location.href
  history.pushState(null, 'Expressway', window.location.origin)
  history.pushState(null, 'Expressway', currentUrl)

  window.addEventListener('popstate', () => {
    history.pushState(null, 'Expressway', window.location.origin)
  })
}
